import { render, staticRenderFns } from "./NewsAndUpdates.vue?vue&type=template&id=271e0fdf&scoped=true&"
import script from "./NewsAndUpdates.vue?vue&type=script&lang=js&"
export * from "./NewsAndUpdates.vue?vue&type=script&lang=js&"
import style0 from "./NewsAndUpdates.vue?vue&type=style&index=0&id=271e0fdf&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271e0fdf",
  null
  
)

export default component.exports